// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"311":"b5bee5e4","488":"e5b1d5ce"}[chunkId] + ".chunk.js";
};